import { FileRoleType } from '@/common/types/ApiResponseTypes.type';

const userTypeTitleConvertor = (userType: FileRoleType) => {
  const titles: Record<FileRoleType, string> = {
    body: 'بیمه گذار',
    culprit: 'مقصر',
    damaged: 'زیاندیده',
    initial: 'بازدید اولیه',
  };
  return titles[userType];
};

export default userTypeTitleConvertor;
